import { CSSProperties } from "react";

import { usePerformanceChart, useTheme } from "@hooks";
import { constants } from "@layout";

export const useStyles = () => {
  const { theme } = useTheme();

  const { width } = usePerformanceChart();

  const styles: Record<string, CSSProperties> = {
    container: {
      width,
      userSelect: "none",
      paddingLeft: constants.divPadding,
      paddingRight: constants.divPadding,
      backgroundColor: theme.chart.performance.background,
      borderRadius: constants.radius.view,
    },
  };

  return styles;
};
